import { Box, Pressable } from '@rbilabs/universal-components';

import { getDesignToken, primitive } from 'styles/constants';
export const Container = Box.withConfig({
  backgroundColor: getDesignToken('background-card'),
  borderRadius: primitive.$borderRadius,
  marginY: '$4',
  paddingX: { base: '$4', md: '$6' },
  paddingY: { base: '$4', md: '$6' },
});

export const DescriptionContainer = Pressable.withConfig({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
});
